import { render, staticRenderFns } from "./AddAdvisory.vue?vue&type=template&id=090dfe78&scoped=true"
import script from "./AddAdvisory.vue?vue&type=script&lang=js"
export * from "./AddAdvisory.vue?vue&type=script&lang=js"
import style0 from "./AddAdvisory.vue?vue&type=style&index=0&id=090dfe78&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "090dfe78",
  null
  
)

export default component.exports